export const UIT_API_KEY = 'b20fefd2-ae9f-4f0a-b8df-4ac792b7fac6';